// ContactForm.js

const ContactForm = () => {
    return (
        <div className="contact-form">
            <form name="contact" action="https://formspree.io/f/xwkavedl" method="POST">
                <label className="sr-only" htmlFor="name">Your Name</label>
                <input type="text" name="name" id="name" className="name" placeholder="Your Name" required></input>

                <div className="contact-form__email-phone">
                    <label className="sr-only" htmlFor="email">Email</label>
                    <input type="text" name="email" id="email" className="email" placeholder="Email Address (Optional)"></input>

                    <label className="sr-only" htmlFor="phone">Phone No.</label>
                    <input name="phone" id="phone" className="phone" pattern="[0-9]*" inputMode="numeric"  placeholder="Telephone Number" required />
                </div>

                <label className="sr-only" htmlFor="city">Your city</label>
                <input type="text" name="city" id="city" className="city" placeholder="City" required></input>
                
                <label className="sr-only" htmlFor="message">Message</label>
                <textarea type="text" name="message" id="message" className="message" cols={30} rows={5} placeholder="Message" required/>

                <button className="contact-form__submit primary-button" type="submit">Submit Enquiry</button>
            </form>
        </div>
    )
}

export default ContactForm;